export default __webpack_public_path__ + "static/media/skill development-06.6d9c1e07.png";